import { styled } from 'styled-components';
import NawyNowForm from './NawyNowForm';
import ImageWrapper from '../../../new-components/ImageWrapper';
import NawyNowFormLicenseIcon from '../../../new-components/svg-icons/NawyNowLicenseIcon';
import NawyNowFormEmailIcon from '../../../new-components/svg-icons/NawyNowEmailIcon';
import NawyNowDocumentIcon from '../../../new-components/svg-icons/NawyNowDocumentIcon';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';

interface MNawyNowFinancingProps {
  areas: any[];
  propertyTypes: any[];
  compounds: any[];
  formRef: React.RefObject<HTMLDivElement>;
}

const MNawyNowFinancing = ({
  areas,
  propertyTypes,
  compounds,
  formRef
}: MNawyNowFinancingProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation('nawy-now');
  return (
    <Container ref={formRef}>
      {/* <div className="finance-info">
        <ImageWrapper
          src={'/assets/images/common/top-compound-form.png'}
          alt="contact-us"
          fill
          objectFit="cover"
        />
      </div> */}

      <div className="info-side">
        {isMobile && (
          <ImageWrapper
            src={'/assets/images/common/top-compound-form.png'}
            alt="contact-us"
            fill
            objectFit="cover"
          />
        )}
        <span className="title">{t('form_header')}</span>
        <span className="subtitle">{t('form_subtitle')}</span>

        {!isMobile && (
          <>
            {' '}
            <div className="info-section">
              <NawyNowFormLicenseIcon />
              <div className="info-section-container">
                <span className="info-section-title">
                  {t('license_number')}
                </span>
                <span className="info-subtitle">{t('license')}</span>
              </div>
            </div>
            <div className="info-section">
              <NawyNowFormEmailIcon />
              <div className="info-section-container">
                <span className="info-section-title">{t('email')}</span>
                <span className="info-subtitle">Customer-support@nawy.com</span>
              </div>
            </div>
            <div className="info-section document">
              <NawyNowDocumentIcon />
              <div className="document-btn">{t('download_fra_document')}</div>
            </div>
          </>
        )}
      </div>

      <div className="content container-fluid">
        <NawyNowForm
          areas={areas?.map((area: any) => ({
            value: area.value,
            label: area.options.displayedValue
          }))}
          propertyTypes={propertyTypes?.map((propertyType: any) => ({
            value: propertyType.id,
            label: propertyType.name
          }))}
          compounds={compounds?.map((compound: any) => ({
            value: compound.id,
            label: compound.name
          }))}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 566px;
  position: relative;
  width: 100vw;
  margin-inline-start: -50vw;
  inset-inline-start: 50%;

  .info-side {
    display: flex;
    height: 190px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 32px 24px;
    width: 100vw;
    border-radius: 0px 0px 18px 18px;
    background: linear-gradient(143deg, #183449 -2.53%, #7693bf 144.75%);
    gap: 4px;

    .title {
      color: #fff;
      font-family: materialSemiBold;
      font-size: 22px;
    }
    .subtitle {
      color: #fff;
      font-family: materialLight;
      font-size: 16px;
    }
    .info-section {
      display: flex;
      flex-direction: row;
      gap: 8px;
      margin-bottom: 8px;

      &.document {
        margin-top: 16px;
      }

      .info-section-container {
        display: flex;
        flex-direction: column;
        .info-section-title {
          color: #fff;
          font-family: materialLight;
          font-size: 12px;
        }

        .info-subtitle {
          color: #cfcfcf;
          font-family: materialLight;
          font-size: 12px;
        }
      }
    }
    .document-btn {
      color: #fff;
      font-family: materialMedium;
      font-size: 14px;
      text-decoration: underline;
    }
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: -35px;
    z-index: 10;

    > div {
      border-radius: 12px;
      background: #fbfcfe;
      box-shadow: 0px 0px 9px 0px rgba(26, 32, 40, 0.07);
    }
  }

  form button {
    padding: 0px;
  }
`;

export default MNawyNowFinancing;
